/* * @Author: 郭通浩 * @Date: 2019-02-14 11:57:08 * @Last Modified by: 郭通浩 * @Last Modified time:
2019-02-15 10:21:08 */
<template lang="pug">
.multipe-choice
  .question-box
    Form(:model="question")
      .question-stem
        Button(icon="md-add",style='color:#3A76D2;border: 1px solid #3A76D2;margin-left: 12px;transform: translateY(-10px);',
          @click='showAIDialog()',v-if='enableAI') AI生成
        Modal(v-model="aiDialogVisible" title="AI生成" @on-ok="generateCase")
          Form(:model="aiForm" :label-width="80")
            FormItem(label="生成数量")
              InputNumber(v-model="aiForm.count" :min="1" :max="10" placeholder="请输入生成数量")
            FormItem(label='提示词',prop="stem")
              Input(v-model='aiForm.system' placeholder='请填写提示词'
                type="textarea" :rows="3")
        FormItem
          Input(type='text',placeholder='题目内容',v-model='question.stem')
        iDelModel(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
      .question-tips(v-show='isEditTips')
        FormItem
          Input(type='text',placeholder='编辑提示信息',v-model='question.tips')
      .question-metas
        FormItem(v-for='(item,index) in question.metas',:key='index')
          Select(v-model="item.departId")
            Option(v-for='(item2,index2) in departList',
                    :value="item2.id",
                    :key="index2") {{item2.departmentName}}
          iTag(:tag-data='question.metas[index].content',style="width:530px;float:right")
          Icon(type="ios-close-circle",@click='delMeta(index)')
        FormItem
          Button(@click='addMeta') + 添加
      .question-answer
        FormItem(label='正确答案',label-position="right",:label-width="80")
          CheckboxGroup(v-model='question.answer')
            Checkbox(v-for='(item,index) in question.metas',
            :label='index',
            :key='index',
            :value='index') {{"选项"+(index+1)}}
      .question-analysis
        FormItem(label='答案解析',label-position="right",:label-width="80")
          Input(type='textarea',v-model='question.analysis',:rows="3")
      .question-score
        FormItem(label='分值',label-position="right",:label-width="80")
          InputNumber(:max='100',:min='0',v-model='question.score')
      .question-edit
        isEditTips(:is-edit='isEditTips' :event='editTips')
</template>
<script>
// import { mapState } from "vuex";
import iTag from "@/components/common/iTag.vue";
import iDelModel from "@/components/common/iDelModel";
import isEditTips from "@/components/common/iEditTips";
import Bus from "../../utils/bus";
export default {
  components: {
    iDelModel,
    isEditTips,
    iTag
  },
  props: ["data", "haId", "taskId", "enableAI"],
  data() {
    return {
      question: {
        tips: "",
        metas: [{ departId: "", content: [] }],
        answer: [],
        stem: "",
        analysis: "",
        score: 0
      },
      isEditTips: false,
      // caseValue: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      departList: [],
      aiDialogVisible: false,
      aiForm: {}
    };
  },
  methods: {
    showAIDialog() {
      this.aiDialogVisible = true;
      this.aiForm = { count: 1, system: "" };
    },
    generateCase() {
      if (this.taskId === "" || this.taskId === null || this.taskId === undefined) {
        this.$Message.error("无法生成！原因：需先保存当前场景！");
        return;
      }
      const data = {
        inputs: {
          opt_type: "FILLBLANKS",
          count: this.aiForm.count,
          pyId: this.$store.state.Case.basic.id,
          tsId: this.taskId,
          haId: this.haId,
          gen_dept_chId: sessionStorage.getItem("chId"),
          score: 2,
          system: this.aiForm.system
        }
      };
      this.$http.generateCase(data).then((res) => {
        if (res.data.success) {
          this.$Message.success("保存成功");
          if (this.taskId !== this.haId) {
            Bus.$emit("refresh-task", this.taskId);
          } else {
            this.$emit("refresh-query");
          }
        }
      });
    },
    addMeta() {
      // 添加选项
      this.question.metas.push({ departId: "", content: [] });
    },
    delMeta(x) {
      // 删除选项
      if (this.question.metas.length > 1) {
        this.question.metas.splice(x, 1);
        this.question.answer = [];
      } else {
        return this.$Message.error("至少保留一条选项");
      }
    },
    editTips() {
      // 编辑提示
      this.question.isEditTips = !this.question.isEditTips;
    },
    delModel() {
      this.$emit("delModel");
    }
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        this.question = this.data;
      }
      this.$emit("data1:data", this.question);
    });
    if (this.$parent.hallList && this.$parent.hallList.length > 3) {
      this.departList = this.$parent.hallList;
      this.departList.forEach((e) => {
        e.departmentName = e.name;
      });
    } else {
      this.departList =
        this.Case.caseData[this.caseValue[sessionStorage.getItem("CaseStage") - 1]].taskHome;
    }
    this.departList = this.departList.filter((value) => {
      return value.departmentName !== "我的办公室" && value.departmentName !== "领导办公室";
    });
    console.log(this.departList);
  },
  computed: {
    caseValue() {
      return this.$store.state.Case.caseValue;
    },
    Case() {
      return this.$store.state.Case;
    }
  }
  // computed: mapState({
  //   // 映射 this.Case 为 store.state.Case
  //   Case() {
  //     return this.$store.state.Case;
  //   }
  // })
};
</script>

<style lang="stylus" scope>
.multipe-choice
  width 790px
  padding 24px 16px 24px 44px
  .question-box
    .question-stem
      position relative
      .ivu-form-item-content
        width 75%
    .question-metas
      .ivu-form-item-content
        margin-right 25px
        position relative
        .ivu-input
          margin 0
        .ivu-select
          width 168px
          position relative
        // .ivu-input-wrapper
        // padding-right 170px
        // position absolute
        // top 1px
        // left 170px
        // z-index 1
        .ivu-icon-ios-close-circle
          font-size 22px
          position absolute
          top 6px
          right -25px
          color #E72020FF
          z-index 2
          &:hover
            cursor pointer
    .question-analysis
      textarea
        resize none
</style>
